import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { PaquetesPendientesList } from "./paquetes/list";
import { SobresPendientesList } from "./sobres/list";

interface Props {
    value: models.PendientesCargaDescarga;
    onQuitarPaquete: (x: models.PaquetePendienteDto) => void | Promise<void>;
    onQuitarSobre: (x: models.PaquetePendienteDto) => void | Promise<void>;
}

class PendientesCargaDescargaNoRx extends React.PureComponent<Props> {
    render() {
        return (
            <div>
                {kea.autogrid(6, [
                    <PaquetesPendientesList value={this.props.value.PaquetesPendientes} onQuitar={this.props.onQuitarPaquete} />,
                    <SobresPendientesList value={this.props.value.SobresPendientes} onQuitar={this.props.onQuitarSobre} />,
                ])}
            </div>
        )
    }
}

export const PendientesCargaDescarga = componentToRx(PendientesCargaDescargaNoRx);


// WEBPACK FOOTER //
// ./app/features/componentes/cargas/pendientes/index.tsx